<template>
  <div v-if="dialogVisible">
    <el-dialog :title="$t('lang.ConfigSetting.edit')" :visible.sync="dialogVisible" width="40%" center>
      <div style="display: flex; justify-content: center;">
        <el-form ref="ruleForm" style="width: 80%" label-width="200px" class="demo-ruleForm ">
          <el-form-item :label="`${$t('lang.ConfigSetting.Rule')}：`" prop="name">
            <el-button type="primary" size="mini" @click="OnOff" v-if="DialogFromData.enabled">
              {{$t('lang.ConfigSetting.DISABLE')}}
            </el-button>
            <el-button v-else type="danger" size="mini" @click="OnOff" >
              {{$t('lang.ConfigSetting.DEABLE')}}
            </el-button>
          </el-form-item>
          <el-form-item :label="`${$t('lang.ConfigSetting.Name')}：`" prop="name">
            <el-input size="small" class="Form-Input-Width" v-model="DialogFromData.name"></el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.ConfigSetting.Protocol')}：`" prop="name">
            <el-select :placeholder="$t('lang.ConfigSetting.pleaseChoose')" v-model="DialogFromData.proto" size="small" class="Form-Input-Width">
              <el-option
                v-for="item in protocolList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="`${$t('lang.ConfigSetting.Sourceport')}：`" prop="name">
            <el-input size="small" class="Form-Input-Width" v-model="DialogFromData.src_port"></el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.ConfigSetting.SourceIPaddress')}：`" prop="name">
            <select-input 
              :SelectArr="IpList" 
              :SelectValue="DialogFromData.src_ip" 
              @GetSelectValue="Src_ipSelectInput" 
              :widths="4">
            </select-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.ConfigSetting.ExternalIPaddress')}：`" prop="name">
            <select-input 
              :SelectArr="IpList" 
              :SelectValue="DialogFromData.src_dip"
              @GetSelectValue="Src_dipSelectInput" 
              :widths="4">
            </select-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.ConfigSetting.InternalIPaddress')}：`" prop="name">
            <select-input 
              :SelectArr="IpList" 
              :SelectValue="DialogFromData.dest_ip"
              @GetSelectValue="Dest_ipSelectInput" 
              :widths="4">
            </select-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.port.outerPort')}：`" prop="name">
            <el-input size="small" class="Form-Input-Width" v-model="DialogFromData.src_dport"></el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.port.innnerPort')}：`" prop="name">
            <el-input size="small" class="Form-Input-Width" v-model="DialogFromData.dest_port"></el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.ConfigSetting.EnableNATLoopback')}：`" prop="name">
            <el-checkbox v-model="DialogFromData.reflection"></el-checkbox>
          </el-form-item>
          <el-form-item :label="`${$t('lang.ConfigSetting.Extraarguments')}：`" prop="name">
            <el-input size="small" class="Form-Input-Width" v-model="DialogFromData.extra"></el-input>
          </el-form-item>
        </el-form>
      </div>
     
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">{{$t('lang.ConfigSetting.cancel')}}</el-button>
        <el-button size="small" type="danger" @click="editRedirect">{{$t('lang.ConfigSetting.SaveApply')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import SelectInput from '../../SelectInput/index'
import { cloneDeep, isEqual} from 'lodash'
import { updateConfig } from '@/api/configurationlist'

export default {
  props:["deviceDid", "deviceSn", 'IpList'],
  components: {
    SelectInput,
  },
  data() {
    return {
      dialogVisible: false,
      DialogFromData: {},
      protocolList:[
        {value:'tcp udp',label:'TCP+UDP'},
        {value:'tcp',label:'TCP'},
        {value:'udp',label:'UDP'},
        {value:'other',label: this.$t('lang.port.other')}
      ],
      wanList:[
        {value:'wan',label:'wan'}
      ],
      lanList:[
        {value:'lan',label:'lan'}
      ],
      index: 0,
      originalData: {}
    }
    
  },
  methods: {
    show(item, index) {
      this.DialogFromData = cloneDeep(item)
      this.DialogFromData.reflection = this.DialogFromData.reflection == '0' ? false : true
      this.dialogVisible = true
      this.index = index
      this.originalData = cloneDeep(this.DialogFromData)
    },
    //启用禁用
    OnOff(){
      this.DialogFromData.enabled=this.DialogFromData.enabled==''?true:false
    },
    //修改源Ip地址
    Src_ipSelectInput(props){
      this.DialogFromData.src_ip=props
    },
    //修改外部Ip地址
    Src_dipSelectInput(props){
      // console.log(props)
      this.DialogFromData.src_dip=props
    },
    //修改内部Ip地址
    Dest_ipSelectInput(props,index){
      console.log(props,index)
      if(index==undefined){
        this.DialogFromData.dest_ip=props
      }
      else{
        this.data[index].options.dest_ip=props
      }
    },
    editRedirect(){
      if(!isEqual(this.DialogFromData, this.originalData)) {
        // 0是禁用，其他的是开启
        let dataCopy = cloneDeep(this.DialogFromData)
        dataCopy.enabled = dataCopy.enabled == true ? '1' : '0'
        dataCopy.reflection = dataCopy.reflection == true ? '1' : '0'
        let data=[
          {section: "redirect",config: "firewall",action:0,index:[this.index],server: "firewall",options:{...dataCopy}}
        ]
        console.log(data);
        updateConfig(this.deviceSn,this.deviceDid,data).then((res)=>{
          if(res.data.data.mess===0){
            this.$message({
              showClose: true,
              message: this.$t('lang.ConfigSetting.Successfulconfiguration'),
              type: 'success'
            });
            this.$emit('updateData')
            this.dialogVisible = false
          }else {
            this.$message({
              showClose: true,
              message: this.$t('lang.ConfigSetting.Configurationerror'),
              type: 'warning'
            });
          }
        })
      }else{
        this.dialogVisible = false
      }
      
    },
    
  }
}
</script>
<style scoped>
.Form-Input-Width{
  width: 4rem;
}
.el-form-item__content{
  line-height: 20px !important;
}
</style>